export class CompanySelectors {
    selectors = [];
    constructor(company) {
        this.set(company);
    }
    set(company) {
        const { closingFields = [], cancellationFields = [], createFields = [], selfAdjustFields = [] } = company;
        const dirty = [...closingFields, ...cancellationFields, ...createFields, ...selfAdjustFields].map(({ listName }) => listName);
        this.selectors = [...new Set(dirty.filter((d) => Boolean(d)))];
    }
    get() {
        return [...this.selectors];
    }
}
